import { fromExtent as polygonFromExtent } from 'ol/geom/Polygon';
import { isEmpty as isEmptyExtent } from 'ol/extent';
import { extend as extendExtent } from 'ol/extent';

export default {
    data() {
        return {

        }
    },
    computed: {
    },
	methods: {
        zoomToFeatures: function(map, features = [], source = null, scale = 1.5, duration = 1000){
            let viewExtent = null;
            if(features) {
                features.forEach((feat, idx) => {
                    let fExtent = feat.getGeometry().getExtent();
                    if(viewExtent){
                        extendExtent(viewExtent, fExtent);
                    }else{
                        viewExtent = fExtent;
                    }
                });
            }else if (source) {
                viewExtent = source.getExtent();
            }
            if(viewExtent && !isEmptyExtent(viewExtent)) {
                let geom = polygonFromExtent(viewExtent);
                geom.scale(scale || 1.5);
                map.zoomToExtent(geom.getExtent(), duration || 1000);
            }
        },
	}
}